// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"t4-z","subtitle":"u4-z","wrapper":"v4-z","leftArrow":"w4-z","rightArrow":"x4-z"};